document.addEventListener('click', async (e) => {
  const btn = e.target.closest('#load-more-btn');
  if (!btn) return;

  const nextUrl = btn.dataset.nextUrl;
  if (!nextUrl) return;

  btn.classList.add('loading');
  btn.disabled = true;

  try {
    const res = await fetch(nextUrl);
    const text = await res.text();

    const html = document.createElement('div');
    html.innerHTML = text;

    const newItems = html.querySelectorAll('#product-grid .grid__item');
    const grid = document.querySelector('#product-grid');

    newItems.forEach(item => grid.appendChild(item));

    const newBtn = html.querySelector('#load-more-btn');

    if (newBtn) {
      btn.dataset.nextUrl = newBtn.dataset.nextUrl;
      btn.classList.remove('loading');
      btn.disabled = false;
    } else {
      btn.remove(); // last page
    }
  } catch (err) {
    console.error(err);
    btn.classList.remove('loading');
    btn.disabled = false;
  }
});




// $(document).ready(function(){
//   $('.shop-by-category-advanced__top').slick({
//     dots: false,
//     arrows: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     slidesToShow: 3,   // Desktop
//     slidesToScroll: 1,

//     responsive: [
//       {
//         breakpoint: 1024, // Tablet
//         settings: {
//           slidesToShow: 2
//         }
//       },
//       {
//         breakpoint: 768, // Mobile
//         settings: {
//           slidesToShow: 1
//         }
//       }
//     ]
//   });
// });


jQuery(document).ready(function($){
    jQuery('.footer').find('.footer-block__heading').click(function(){
        var isActive = jQuery(this).hasClass("active");
        jQuery('.footer-block__heading').removeClass('active')
            if (!isActive) {
        jQuery(this).toggleClass('active');
        }
        jQuery(this).next().slideToggle('fast'); //Hide the other panels
        jQuery(".footer-block__heading + div,.footer-block__heading + .footer-block__details-content ").not(jQuery(this).next()).slideUp('fast');
    });
 });

 document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="http"]').forEach(function (link) {
    if (!link.href.includes(window.location.hostname)) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});

$(document).ready(function () {
  $('#custom_close').click(function () {
    $('body').removeClass('overflow-hidden-tablet');
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const phoneInput = document.getElementById("ContactForm-phone");

  if (!phoneInput) return;

  // Allow only numbers while typing
  phoneInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "");
  });

  // Prevent pasting non-numeric content
  phoneInput.addEventListener("paste", function (e) {
    e.preventDefault();
    const pastedData = (e.clipboardData || window.clipboardData)
      .getData("text")
      .replace(/[^0-9]/g, "");
    this.value += pastedData;
  });
});



// let lastScroll = 0;
// const header = document.querySelector('.section-header');

// window.addEventListener('scroll', () => {
//   if (!header) return;

//   let currentScroll = window.pageYOffset;

//   // Top pe ho → always show
//   if (currentScroll <= 0) {
//     header.classList.remove('hide');
//     return;
//   }

//   // scroll down
//   if (currentScroll > lastScroll && currentScroll > 100) {
//     header.classList.add('hide');
//   } 
//   // scroll up
//   else if (currentScroll < lastScroll) {
//     header.classList.remove('hide');
//   }

//   lastScroll = currentScroll;
// });


let lastScroll = 0;
const header = document.querySelector('.section-header');

window.addEventListener('scroll', () => {
  if (!header) return;

  let currentScroll = window.pageYOffset;

  // Top pe → show
  if (currentScroll <= 0) {
    header.classList.remove('hide');
    return;
  }

  // scroll down → hide
  if (currentScroll > lastScroll && currentScroll > 100) {
    header.classList.add('hide');
  } 
  // scroll up → show
  else {
    header.classList.remove('hide');
  }

  lastScroll = currentScroll;
});
